import Vue from 'vue'
import request from '@/helpers/request'
import store from '@/store'
import WindowFactory from '@/factory/window'
import moment from 'moment'
import ServerValidationError from '@/helpers/ServerValidationError'
import snack from '@/helpers/snack'

export default {
  SAVE_WINDOW: ({ commit, state }, index) => {
    if (store.getters.windows[index]) {
      const window = store.getters.windows[index]
      if (window.status === WindowFactory.CREATE) {
        request(
          'POST',
          `${Vue.config.server}/${Vue.config.modules.crm.api.windows.all
            .replace('$unit_id', store.getters.workPlace.unit_id)
            .replace('$workplace_id', store.getters.workPlace.id)}`,
          {
            begin_at: moment(window.begin_at).format(Vue.config.format.serverDate),
            schedule: window.schedule,
          },
          true,
        ).then(
          response => {
            if (response.data.result === 'success') {
              const data = response.data.data

              store.commit('updateWindowFieldByIndex', {
                index: index,
                key: 'id',
                value: data.id,
                withUpdate: false,
              })

              store.dispatch('SAVE_WINDOW', index + 1)
            }
          },
          response => {},
        )
      } else if (window.status === WindowFactory.UPDATE) {
        request(
          'PUT',
          `${Vue.config.server}/${Vue.config.modules.crm.api.windows.one
            .replace('$unit_id', store.getters.workPlace.unit_id)
            .replace('$workplace_id', store.getters.workPlace.id)
            .replace('$window_id', window.id)}`,
          {
            begin_at: moment(window.begin_at).format(Vue.config.format.serverDate),
            schedule: window.schedule,
          },
          true,
        ).then(
          response => {
            store.commit('updateWindowFieldByIndex', {
              index: index,
              key: 'status',
              value: null,
              withUpdate: false,
            })
            store.dispatch('SAVE_WINDOW', index + 1)
          },
          response => {},
        )
      } else if (window.status === WindowFactory.DELETE) {
        request(
          'DELETE',
          `${Vue.config.server}/${Vue.config.modules.crm.api.windows.one
            .replace('$unit_id', store.getters.workPlace.unit_id)
            .replace('$workplace_id', store.getters.workPlace.id)
            .replace('$window_id', window.id)}`,
          {},
          true,
        ).then(
          response => {
            store.commit('updateWindowFieldByIndex', {
              index: index,
              key: 'status',
              value: null,
              withUpdate: false,
            })
            store.dispatch('SAVE_WINDOW', index + 1)
          },
          response => {},
        )
      } else {
        store.dispatch('SAVE_WINDOW', index + 1)
      }
    } else {
      store.dispatch('GET_WINDOWS')
      store.dispatch('SAVE_WORK_PLACE_SERVICE_CATEGORY', 0)
    }
  },
  SHOW_WINDOW_ERROR: ({ commit, state }, window) => {
    const beginAt = moment(window.begin_at).format(Vue.config.format.date)
    commit('setLoad', false)

    Vue.notify({
      group: 'hasBottomNavigation',
      title: '',
      type: 'error',
      text: Vue.config.localization.ru.windowWithoutInterval.replace('$begin_at', beginAt),
    })
  },
  GET_WINDOWS: ({ commit, state }) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.windows.all
        .replace('$unit_id', store.getters.workPlace.unit_id)
        .replace('$workplace_id', store.getters.workPlace.id)}`,
      {},
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          store.commit('setWindows', data.items)
        }
      },
      response => {
        ServerValidationError.notify(response, 'customerValidation')
      },
    )
  },
  CREATE_WINDOW: ({ commit, state, rootGetters }, payload) => {
    const params = payload.params

    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.windows.create}`,
      {
        params,
        headers: {
          'X-Timezone': rootGetters.timezone ? rootGetters.timezone : 'Europe/Moscow',
        },
      },
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          snack.add(Vue.config.localization.ru.createWindowMessage, 'primary')
          if (payload.callback) {
            payload.callback(response.data.data)
          }
        } else {
          // TODO: Show error dialog
        }
      },
      e => {
        commit('setLoad', false)
        snack.add(Vue.config.localization.ru.createWindowMessageError, 'error')
      },
    )
  },
  UPDATE_WINDOW: ({ commit, state, rootGetters }, { id, params, callback }) => {
    return request(
      'PUT',
      `${Vue.config.server}/${Vue.config.modules.crm.api.windows.update.replace('$id', id)}`,
      {
        params: params,
        headers: {
          'X-Timezone': rootGetters.timezone ? rootGetters.timezone : 'Europe/Moscow',
        },
      },
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          // snack.add(Vue.config.localization.ru.createWindowMessage, 'primary');
          if (callback) {
            callback(response.data.data)
          }
        } else {
          // TODO: Show error dialog
        }
      },
      e => {
        commit('setLoad', false)
        snack.add(Vue.config.localization.ru.createWindowMessageError, 'error')
      },
    )
  },
  async FETCH_WINDOW({ commit, state, rootGetters }, windowID) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.windows.update.replace('$id', windowID)}`,
        {
          params: {
            with: 'booking;booking.services',
          },
          headers: {
            'X-Timezone': rootGetters.timezone ? rootGetters.timezone : 'Europe/Moscow',
          },
        },
        true,
      )
      return response.data.data
    } catch (e) {
      snack.add('Window error')
    }
  },
}
